import { MAT_DATE_FORMATS } from '@angular/material/core';

/**
 * Standard date formats for the entire application
 * Following the format used in DateTransformPipe (dd MMM yyyy)
 */
export const STANDARD_DATE_FORMATS = {
  parse: {
    dateInput: 'dd MMM yyyy',
  },
  display: {
    dateInput: 'dd MMM yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'dd MMM yyyy',
    monthYearA11yLabel: 'MMM yyyy',
  },
};

/**
 * Provider for Angular Material date formats
 * Use this in component providers to apply standard date formats
 */
export const STANDARD_DATE_FORMATS_PROVIDER = {
  provide: MAT_DATE_FORMATS,
  useValue: STANDARD_DATE_FORMATS
}; 